import { Component, input, output, signal } from '@angular/core';
import { AngularModule } from '../../../../../modules/angular.module';
import { ZorroModule } from '../../../../../modules/zorro.module';
import { PlayerButtonComponent } from '../player-button/player-button.component';
import { Activity, Engines, Product } from '@mira-avant/mtlibs';
import { HeaderActivityTitleComponent } from '../header-activity-title/header-activity-title.component';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { CourseService } from '../../../../../services/course.service';
import { LoggedInService } from '../../../../../services/logged-in.service';

@Component({
	selector: 'app-player-header',
	standalone: true,
	imports: [AngularModule, ZorroModule, PlayerButtonComponent, HeaderActivityTitleComponent],
	templateUrl: './player-header.component.html',
	styleUrl: './player-header.component.scss',
})
export class PlayerHeaderComponent {
	public up = output<void>();
	public info = output<void>();
	public next = output<void>();
	public back = input<string[]>([]);
	public activity = input<Activity | undefined>(undefined);
	public enableNext = input<boolean>(false);
	public isStrideCourse = signal<boolean | undefined>(undefined);

	private routerSubscription: Subscription | undefined;

	constructor(
		private router: Router,
		private courseService: CourseService,
		private loggedInService: LoggedInService
	) {
		this.routerSubscription = this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe(async () => {
				await this.loadCourseAndMaybeShowInstructions();
			});
	}

	async ngOnInit() {
		await this.loadCourseAndMaybeShowInstructions();
	}

	private async loadCourseAndMaybeShowInstructions() {
		await this.courseService
			.getCourseByUrl()
			.then(async course => {
				if (course) {
					const courseProduct:Product = await this.courseService.getProduct$(course.uuid);
					this.isStrideCourse.set(courseProduct.engine_name === Engines.STRIDE);
				} else {
					this.isStrideCourse.set(false);
				}
			})
			.catch(error => {
				console.error('Error fetching course:', error);
				this.isStrideCourse.set(false);
			})
			.finally(() => {
				//Show instructions by default if this is not stride
				if (!this.isStrideCourse()) {
					this.info.emit();
				}
			});
	}

	public logout(): void {
		this.loggedInService.logout();
	}

	ngOnDestroy() {
		if (this.routerSubscription) {
			this.routerSubscription.unsubscribe();
		}
	}
}
